import MsgToUserActionTypes from './types'

export const MsgToUserActionCreators = {
  msgToUserState: (msgNumber, details) => ({
    type: MsgToUserActionTypes.MSGTOUSER,
    msgNumber,
    details,
  }),
}
